<template>
  <div>
    <beautiful-chat
      :isSignup="true"
      :signup="signup"
      :participants="participants"
      :titleImageUrl="titleImageUrl"
      :onMessageWasSent="onMessageWasSent"
      :messageList="messageList"
      :newMessagesCount="newMessagesCount"
      :isOpen="isChatOpen"
      :close="closeChat"
      :open="openChat"
      :showEmoji="false"
      :showFile="false"
      :showEdition="true"
      :showDeletion="true"
      :showTypingIndicator="showTypingIndicator"
      :showLauncher="true"
      :showCloseButton="true"
      :colors="colors"
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :disableUserListToggle="false"
      :messageStyling="messageStyling"
      @onType="handleOnType"
      @edit="editMessage"
    />
  </div>
</template>

<script>
import axios from "axios";
import pusher from "../pusher/init";

export default {
  mounted() {
    var channel = pusher.subscribe("register-chat");
    channel.bind(this.authUser.uuid, this.customerStartChat);
    //channel.bind(this.chatSessionUUID, this.customerChats);
  },

  data() {
    return {
      chatSessionUUID: "",
      participants: [
        /* {
          id: "user1",
          name: "Matteo",
          imageUrl: "https://avatars3.githubusercontent.com/u/1915989?s=230&v=4",
        },
        {
          id: "user2",
          name: "Support",
          imageUrl: "https://avatars3.githubusercontent.com/u/37018832?s=200&v=4",
        }, */
      ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl: "", // "https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png",
      messageList: [
        //{ type: "text", author: `me`, data: { text: `Say yes!` } },
        //{ type: "text", author: `user1`, data: { text: `No.` } },
      ], // the list of the messages to show, can be paginated and adjusted dynamically
      newMessagesCount: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: "", // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: "#4e8cff",
          text: "#ffffff",
        },
        launcher: {
          bg: "#4e8cff",
        },
        messageList: {
          bg: "#ffffff",
        },
        sentMessage: {
          bg: "#4e8cff",
          text: "#ffffff",
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222",
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867",
        },
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
    };
  },

  methods: {
    sendMessage(text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1;
        this.onMessageWasSent({ author: this.authUser.uuid, type: "text", data: { text } });
      }
    },
    onMessageWasSent(message) {
      // called when the user sends a message
      //this.messageList = [...this.messageList, message];
      let formData = new FormData();
      formData.append("chatSessionUUID", this.chatSessionUUID);
      formData.append("userUUID", this.authUser.uuid);
      formData.append("message", message.data.text);
      formData.append("role", "agent");
      axios
        .post("/chat/message", formData, {
          headers: { apikey: process.env.VUE_APP_API_KEY, Authorization: "" },
        })
        .then((res) => {
          if (res.data.status == "success") {
            this.messageList = [...this.messageList, message];
          }
        });
    },
    openChat() {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true;
      this.newMessagesCount = 0;
    },
    closeChat() {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false;
    },
    handleScrollToTop() {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType() {
      console.log("Emit typing event");
    },
    editMessage(message) {
      const m = this.messageList.find((m) => m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    },

    signup() {},

    customerStartChat(data) {
      this.participants.push(
        // AUTHOR
        {
          id: this.authUser.uuid,
          name: this.authUser.name,
          imageUrl: this.authUser.photo,
        },
        // User
        {
          id: data.user.uuid,
          name: data.user.name,
          imageUrl: data.user.photo,
        }
      );
      this.messageList.push({ type: "text", author: data.user.uuid, data: { text: data.message } });
      this.chatSessionUUID = data.chatSessionUUID;
      this.isChatOpen = true;
      let channel2 = pusher.subscribe("my-channel");
      channel2.bind(data.chatSessionUUID, this.customerChats);
    },

    customerChats(data) {
      if (data.user.uuid != this.authUser.uuid) {
        this.messageList.push({ type: "text", author: this.authUser.uuid, data: { text: data.message } });
      }
      //let message = { type: "text", author: this.authUser.uuid, data: { text: data.message } };
      //this.messageList = [...this.messageList, message];
    },
  },

  computed: {
    authUser() {
      return this.$store.state.authUser;
    },
  },
};
</script>

<style>
</style>